import * as React from 'react';

import { first } from 'lodash';

import CardContent from 'bundles/expression-of-interest/components/eoi-v1/modal-content/CardContent';
import { useGetCourseById } from 'bundles/expression-of-interest/hooks/useGetCourseById';

export type Props = {
  courseId: string;
};

const CourseCard: React.FC<Props> = ({ courseId }) => {
  const { course, loading } = useGetCourseById(courseId);
  if (!course || loading) {
    return null;
  }

  const link = `/learn/${course.slug}`;

  return (
    <div className="rc-CourseCard list-card-container">
      <CardContent
        // @ts-expect-error URL: string
        photoSrc={course.promoPhotoUrl}
        partnerName={first(course.partners)?.name || ''}
        name={course.name}
        link={link}
      />
    </div>
  );
};

export default CourseCard;
